import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";

import { RootState } from "../../../store";
import { IAgency } from "../../auth/reducers";
import { getBuilding, getBuildings } from "../../building/actions";
import { IBuilding } from "../../building/reducers";
import * as Actions from "../actions";
import DwellingForm from "../components/DwellingForm";
import { IDwelling } from "../reducers";

const mapStateToProps = (state: RootState) => {
  const building: IBuilding = state.buildingReducer.building;
  const buildings: Array<IBuilding> = state.buildingReducer.buildings;
  const buildingsCount: number = state.buildingReducer.buildingsCount;
  const referentials = state.referentialReducer.referentials;
  const agencies: Array<IAgency> = state.authReducer.user.agencies;

  return {
    building,
    buildings,
    buildingsCount,
    referentials,
    agencies,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    addDwelling: (dwelling: IDwelling) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.addDwelling(dwelling, resolve, reject));
      });
    },
    getBuilding: (id: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(getBuilding(resolve, reject, id));
      });
    },
    getBuildings: (page: number, filter: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(getBuildings(resolve, reject, page, filter));
      });
    },
    getDwelling: (id: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.getDwelling(resolve, reject, id));
      });
    },
    updateDwelling: (dwelling: IDwelling) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.updateDwelling(dwelling, resolve, reject));
      });
    },
    uploadDwellingFiles: (id: string, files: any[]) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.uploadDwellingFiles(resolve, reject, id, files));
      });
    },
    removeDwellingFile: (dwellingId: string, fileId: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(
          Actions.removeDwellingFile(resolve, reject, dwellingId, fileId),
        );
      });
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxAppDwellingForm = ConnectedProps<typeof connector>;

export default withRouter(connector(DwellingForm));
